import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

type UseAskAIParams = {
	shop: ShopDto;
};

export function useAskAI({ shop }: UseAskAIParams) {
	return useApiMutation("post", "/shops/{shopId}/ask", {
		notify: { success: false },
		mapVariables: (content: string) => ({
			params: { path: { shopId: shop.id } },
			body: { query: content },
		}),
	});
}
